import { ActionType, createReducer } from 'typesafe-actions';
import { setAvailableBetsAction } from './actions';
import { IBetAvailabilityState } from './types';

export const betAvailabilityState: IBetAvailabilityState = {
  availableBets: [],
};

const actions = {
  setAvailableBetsAction,
};

export const betAvailabilityReducer = createReducer<
  IBetAvailabilityState,
  ActionType<typeof actions>
>(betAvailabilityState).handleAction(setAvailableBetsAction, (state, { payload }) => ({
  ...state,
  availableBets: payload,
}));
